module.exports = __webpack_public_path__ + "static/media/add-cart-black.a8c12f63.svg";